export default __webpack_public_path__ + "static/media/Merchant-portal-settle.cc0b358b.png";